<template>
  <div v-if="show"
    class="trend-arrow">
    <span title="Current Year ISP Goes Down"
        v-if="currentISP - prevISP < 0">
    <font-awesome-icon :icon="['fas', 'long-arrow-alt-down']"
        size="lg" class="has-text-danger"
         v-if="trend < 0"/>
    </span>
    <span title="Current Year ISP Goes Up"
         v-if="currentISP - prevISP > 0">
        <font-awesome-icon :icon="['fas', 'long-arrow-alt-up']"
            size="lg" class="has-text-success"
             v-if="trend > 0"/>
    </span>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLongArrowAltDown,
  faLongArrowAltUp,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faLongArrowAltDown,
  faLongArrowAltUp,
);

export default {
  props: ['prevISP', 'currentISP'],
  computed: {
    show() {
      return this.prevISP && this.prevISP !== '';
    },
    trend() {
      return this.prevISP && this.currentISP ? (this.currentISP - this.prevISP) : 0;
    },
  }
};
</script>
<style lang="sass" scoped>
  @import "@/sass/custom.sass"
  .trend-arrow
    display: inline;
</style>
